module.exports = __webpack_public_path__ + "img/SherlockHuPhD.4a592d52.png";